import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { LoadingFallback } from '@/components/common/LoadingFallback';
import { ROUTES } from '@/constants/routes';
import { ADMIN_ROUTES } from '@/constants/adminRoutes';
import { PromotionFlowLayout } from '@/components/layout/PromotionFlowLayout';
import { AdminLayout } from '@/components/layout/AdminLayout';

import Home from '@/pages/Home';
import Courses from '@/pages/Courses';
import Instructors from '@/pages/Instructors';
import Enroll from '@/pages/Enroll';
import Contact from '@/pages/Contact';
import HelpCenter from '@/pages/HelpCenter';
import Faqs from '@/pages/Faqs';
import About from '@/pages/About';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import Press from '@/pages/Press';
import Careers from '@/pages/Careers';
import Community from '@/pages/Community';
import BecomeInstructor from '@/pages/BecomeInstructor';
import TeachingCenters from '@/pages/TeachingCenters';
import Resources from '@/pages/Resources';
import SignIn from '@/pages/SignIn';
import SignUp from '@/pages/SignUp';
import EnrollmentSetup from '@/pages/EnrollmentSetup';
import AvailabilitySetup from '@/pages/AvailabilitySetup';
import ChooseVerificationMethod from '@/pages/ChooseVerificationMethod';
import Verify from '@/pages/Verify';
import ForgotPassword from '@/pages/ForgotPassword';
import VerifyResetCode from '@/pages/VerifyResetCode';
import ResetPassword from '@/pages/ResetPassword';

import PromotionLanding from '@/pages/PromotionLanding/PromotionLanding';
import PromotionEnrollment from '@/pages/PromotionEnrollment/PromotionEnrollment';
import PromotionProfile from '@/pages/PromotionProfile/PromotionProfile';
import PromotionAvailability from '@/pages/PromotionAvailability/PromotionAvailability';
import PromotionContact from '@/pages/PromotionContact/PromotionContact';
import PromotionConfirmation from '@/pages/PromotionConfirmation/PromotionConfirmation';

import { GuardianPortal } from '@/pages/GuardianPortal';
import { InstructorPortal } from '@/pages/InstructorPortal';
import { StudentPortal } from '@/pages/StudentPortal';

import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminWebsite from '@/pages/AdminWebsite';
import AdminBlogs from '@/pages/AdminBlogs';
import AdminPromotions from '@/pages/AdminPromotions';
import AdminPromotionForm from '@/pages/AdminPromotionForm';
import AdminAlerts from '@/pages/AdminAlerts';

const CourseDetail = lazy(() => import('@/pages/CourseDetail'));
const InstructorProfile = lazy(() => import('@/pages/InstructorProfile'));

export function AppRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      {/* <Routes>
        <Route path={ROUTES.home} element={<Home />} />
        <Route path={ROUTES.courses} element={<Courses />} />
        <Route path="/courses/:slug" element={<CourseDetail />} />
        <Route path={ROUTES.instructors} element={<Instructors />} />
        <Route path="/instructors/:slug" element={<InstructorProfile />} />
        <Route path={ROUTES.enroll} element={<Enroll />} />
        <Route path={ROUTES.contact} element={<Contact />} />
        <Route path={ROUTES.helpCenter} element={<HelpCenter />} />
        <Route path={ROUTES.faqs} element={<Faqs />} />
        <Route path={ROUTES.about} element={<About />} />
        <Route path={ROUTES.blog} element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path={ROUTES.press} element={<Press />} />
        <Route path={ROUTES.careers} element={<Careers />} />
        <Route path={ROUTES.community} element={<Community />} />
        <Route path={ROUTES.becomeInstructor} element={<BecomeInstructor />} />
        <Route path={ROUTES.teachingCenters} element={<TeachingCenters />} />
        <Route path={ROUTES.resources} element={<Resources />} />
        <Route path={ROUTES.signIn} element={<SignIn />} />
        <Route path={ROUTES.signUp} element={<SignUp />} />
        <Route path={ROUTES.enrollmentSetup} element={<EnrollmentSetup />} />
        <Route path={ROUTES.availabilitySetup} element={<AvailabilitySetup />} />
        <Route path={ROUTES.chooseVerificationMethod} element={<ChooseVerificationMethod />} />
        <Route path={ROUTES.verifyAccount} element={<Verify />} />
        <Route path={ROUTES.forgotPassword} element={<ForgotPassword />} />
        <Route path={ROUTES.verifyResetCode} element={<VerifyResetCode />} />
        <Route path={ROUTES.resetPassword} element={<ResetPassword />} />

        <Route path={ROUTES.guardianPortal} element={<GuardianPortal />} />
        <Route path={ROUTES.instructorPortal} element={<InstructorPortal />} />
        <Route path={ROUTES.studentPortal} element={<StudentPortal />} />
        
        <Route path="/promotion" element={<Navigate to={ROUTES.promotion} replace />} />
        <Route path="/promotion/:region" element={<PromotionLanding />} />
        <Route element={<PromotionFlowLayout />}>
          <Route path={ROUTES.promotionEnrollment} element={<PromotionEnrollment />} />
          <Route path={ROUTES.promotionProfile} element={<PromotionProfile />} />
          <Route path={ROUTES.promotionAvailability} element={<PromotionAvailability />} />
          <Route path={ROUTES.promotionContact} element={<PromotionContact />} />
          <Route path={ROUTES.promotionConfirmation} element={<PromotionConfirmation />} />
        </Route>

        <Route path={ADMIN_ROUTES.login} element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          <Route path={ADMIN_ROUTES.dashboard} element={<AdminDashboard />} />
          <Route path={ADMIN_ROUTES.website} element={<AdminWebsite />} />
          <Route path={ADMIN_ROUTES.blogs} element={<AdminBlogs />} />
          <Route path={ADMIN_ROUTES.promotionForm} element={<AdminPromotionForm />} />
          <Route path={ADMIN_ROUTES.promotions} element={<AdminPromotions />} />
          <Route path={ADMIN_ROUTES.alerts} element={<AdminAlerts />} />
        </Route>
      </Routes> */}

      <Routes>
        <Route path="/promotion" element={<Navigate to={ROUTES.promotion} replace />} />
        <Route path="/promotion/:region" element={<PromotionLanding />} />
        <Route element={<PromotionFlowLayout />}>
          <Route path={ROUTES.promotionEnrollment} element={<PromotionEnrollment />} />
          <Route path={ROUTES.promotionProfile} element={<PromotionProfile />} />
          <Route path={ROUTES.promotionAvailability} element={<PromotionAvailability />} />
          <Route path={ROUTES.promotionContact} element={<PromotionContact />} />
          <Route path={ROUTES.promotionConfirmation} element={<PromotionConfirmation />} />
        </Route>
        <Route path="*" element={<Navigate to={ROUTES.promotion} replace />} />
      </Routes>
    </Suspense>
  );
}